import React from "react";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "../language";

// Sprachauswahl im Portal-Header (gleiche Komponente wie auf der Login-Seite)
function LanguageTooltip({ align = "right" }) {
  const { t } = useTranslation();
  return <LanguageDropdown align={align} label={t("lgLanguage")} />;
}

export default LanguageTooltip;
